import { useAuthStore } from '../store/authStore';
import { useEntitlementsStore } from '../store/entitlementsStore';
import { isCloudReadOnly } from './cloudAccess';

/**
 * `isCloudReadOnly()` (plans/cloudAccess.js) for a component: re-renders when
 * the plan's capabilities, the session or the last /auth/usage answer change.
 */
export function useCloudReadOnly() {
  useEntitlementsStore((s) => `${s.source}|${s.capabilitiesKnown}|${(s.capabilities || []).join(',')}`);
  useAuthStore((s) => s.isAuthenticated);
  useAuthStore((s) => s.user?._usage);
  return isCloudReadOnly();
}
